import { useNotificationsContext } from "common/context/NotificationsProvider"
import notification from "common/utils/notification"
import {
  ImportacionFacturaEuProps,
  ImportacionFacturaExcProps,
} from "context/initialStates/_globals"
import { setHideValidarEmpresaLoadingModal } from "features/User/redux/slices/empresaSlice"
import {
  userIsNotVerificado,
  userIsVerificado,
} from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useEffect } from "react"
import { empresaActivaStore } from "utils/local-storage-key-store"
import { createConnection } from "../utils/createSignalR"
import { useUploadFacturaeGlobal } from "./useUploadFacturaeGlobal"

let connectionBde: $TSMigrationFixMe
let connectionNotifications: $TSMigrationFixMe

const useRealTime = () => {
  const dispatch = useDispatch()
  const {
    setImportacionesFacturaEGlobal,
    setImportacionesFacturaExcGlobal,
    setImportacionesSageGlobal,
  } = useUploadFacturaeGlobal()
  // @ts-expect-error TS(2339): Property 'setIsNewNotification' does not exist on ...
  const { setIsNewNotification } = useNotificationsContext()

  useEffect(() => {
    // eslint-disable-next-line prettier/prettier, @typescript-eslint/no-extra-semi
    ;(async () => {
      if (!sessionStorage.getItem("access_token")) return
      connectionBde = createConnection({
        hub: "SignalR/erp/ERPHub",
        baseURL: import.meta.env.REACT_APP_GATEWAY,
      })
      connectionNotifications = createConnection({
        hub: "SignalR/Notifications/NotificationsHub",
        baseURL: import.meta.env.REACT_APP_GATEWAY,
      })

      connectionBde.start()
      connectionNotifications.start()

      await Promise.all([connectionBde, connectionNotifications])
    })()

    return () => {
      connectionBde?.stop()
      connectionNotifications?.stop()
    }
  }, [])

  useEffect(() => {
    connectionBde?.on("UserValidated", (data: $TSMigrationFixMe) => {
      dispatch(userIsVerificado(data))
    })

    connectionBde?.on("UserNotValidated", (msg: $TSMigrationFixMe) => {
      dispatch(userIsNotVerificado(msg))
      // Cierra el modal de carga al mostrar el modal de error:
      dispatch(setHideValidarEmpresaLoadingModal())
    })

    connectionBde?.on("DocumentEdiImported", ({ serie }: $TSMigrationFixMe) => {
      notification.success({
        body: `El documento ${serie} a sido importado éxito`,
      })
    })

    connectionBde?.on("ErrorImportDocumentEdi", (msg: $TSMigrationFixMe) => {
      notification.errorServidor({
        body: msg,
      })
    })

    connectionNotifications?.on("NewNotification", (msg: $TSMigrationFixMe) => {
      setIsNewNotification(msg)
    })

    connectionBde?.on("ImportacionesSage", (data: $TSMigrationFixMe) => {
      setImportacionesSageGlobal(data)
    })
    connectionBde?.on(
      "UsuarioEmpresaActivaChanged",
      async (empresaActivaId: string) => {
        empresaActivaStore.set(empresaActivaId)
      }
    )

    /**
     * ImportacionFacturaE
     */
    try {
      connectionBde.on(
        "ImportacionFacturaeStarted",
        (resp: ImportacionFacturaEuProps) => {
          setImportacionesFacturaEGlobal(resp)
        }
      )
      connectionBde.on(
        "ImportacionFacturaESuccessful",
        (resp: ImportacionFacturaEuProps) => {
          setImportacionesFacturaEGlobal(resp)
        }
      )
      connectionBde.on(
        "ImportacionFacturaEError",
        (resp: ImportacionFacturaEuProps) => {
          setImportacionesFacturaEGlobal(resp)
        }
      )
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error conectando a ImportacionFacturaE:", error)
    }

    /**
     * ImportacionFacturaExcel
     */
    try {
      connectionBde.on(
        "ImportacionExcelFactura",
        (resp: ImportacionFacturaExcProps) => {
          setImportacionesFacturaExcGlobal(resp)
        }
      )
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error conectando a ImportacionFacturaExcel:", error)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])
}

export default useRealTime
